import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { Select, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { BasicForm } from "@components/shared";

const VARIETY_OPTIONS = [
  { value: "1", label: "ClearScreen" },
  { value: "4", label: "Legacy ClearScreen" },
  { value: "2", label: "360" },
  { value: "3", label: "Engagement" },
];

export default function ConceptualRootForm({ onSuccess = () => {} }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [variety, setVariety] = useState("1");
  const [concepts, setConcepts] = useState([]);
  const [loadingConcepts, setLoadingConcepts] = useState(false);

  useEffect(() => {
    fetchConcepts(variety);
  }, [variety]);

  function fetchConcepts(selectedVariety) {
    setLoadingConcepts(true);
    axios
      .post(`/retrieve-conceptual-root-concepts/`, {
        variety: Number(selectedVariety),
      })
      .then(({ data }) => {
        const rows = Array.isArray(data.response) ? data.response : [];
        setConcepts(
          rows.map((row) => ({
            value: row.concept,
            label: `${row.concept} — ${row.label}`,
          }))
        );
        setLoadingConcepts(false);
      })
      .catch((err) => {
        setLoadingConcepts(false);
        setConcepts([]);
        toast.error(err);
      });
  }

  function onSubmit(formData) {
    setLoading(true);
    axios
      .post(`/conceptual-roots/`, {
        concept: formData.concept,
        variety: Number(variety),
        is_composite: !!formData.is_composite,
      })
      .then(({ data }) => {
        setLoading(false);
        toast.success(t("created"));
        onSuccess(data.response[0]);
        fetchConcepts(variety);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "concept",
      label: "Concept",
      initialValue: "",
      required: true,
      select: true,
      options: concepts,
      disabled: loadingConcepts || !concepts.length,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "is_composite",
      label: "Composite",
      initialValue: false,
      checkbox: true,
      schema: () => Yup.boolean(),
    },
  ];

  return (
    <Stack gap="sm">
      <Select
        label={t("variety")}
        data={VARIETY_OPTIONS}
        value={variety}
        onChange={(value) => setVariety(value || "1")}
        required
      />
      <BasicForm
        key={variety}
        buttonProps={{ fullWidth: true }}
        loading={loading || loadingConcepts}
        onSubmit={onSubmit}
        fields={fields}
      />
    </Stack>
  );
}
